import { IAttrValue } from "@multiweb/types/contracts";
import { IValidatable } from "../../../../../../UI.BaseControls/ControlInterfaces";
import { Column } from "../../../../../../UI.Controls/DataGridSubcontrols/Columns/Column";
import { ContainerEditableControl } from "../../../../Controls/ContainerEditableControl";
import { FormControlParams } from "../../../../Controls/ControlInterfaces";
import { Registrator } from "../../../../Controls/Registrator";
import { NumberColumn } from "../NumColumn";
import { DefaultEditContainerTemplate } from "./DefaultEditContainerTemplate";

export class NumberEditTemplate extends DefaultEditContainerTemplate {
    constructor() {
        super(Registrator.get("NumEditColumn") as (params: FormControlParams) => ContainerEditableControl);
    }

    protected override _createEditElement(column: Column, dataSet: IAttrValue[], parentItem: HTMLElement): { element: HTMLElement; validatableControl: IValidatable } {
        const element = document.createElement("div");
        if (column instanceof NumberColumn) {
            if (column.minValue != null) {
                element.setAttribute("data-minvalue", column.minValue.toString());
            }
            if (column.maxValue != null) {
                element.setAttribute("data-maxvalue", column.maxValue.toString());
            }
        }
        const container = this._createEditContainerElement(dataSet, parentItem, column, element);
        container.dataType = column.dataType;

        return { element: container.element, validatableControl: container };
    }
}
